import { ReadTagsAvailableToSetToDeviceRequest, ReadTagsAvailableToSetToGroupRequest } from '@openapi';
import { getTagsApi } from './configuration';

const tags = {
  getDeviceTags: () => {
    return getTagsApi().readNumberOfDevicesForEachTag();
  },
  getGroupTags: (requestParameters: ReadTagsAvailableToSetToGroupRequest) => {
    requestParameters = requestParameters || '';
    return getTagsApi().readTagsAvailableToSetToGroup(requestParameters);
  },
  getTags: (requestParameters: ReadTagsAvailableToSetToDeviceRequest['deviceId']) => {
    return getTagsApi().readTagsAvailableToSetToDevice({ deviceId: requestParameters });
  },
};

export default tags;
